import React from 'react';
import {
  Dialog,
  DialogBackdrop,
  DialogTitle,
  Transition,
  TransitionChild
} from '@headlessui/react';
import { Fragment, useState } from 'react';
import closeimg from '../public/img/close-icn.svg';
import StyledImage from './StyledImage';
import { IProduct } from '../models';
import { useTranslation } from 'react-i18next';

export default function SizeChartModal({ product }: { product: IProduct }) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const guide = product && product['size-guide'];
  const [sizeMetric] = guide ? guide.size_guide_key?.split('_')?.slice(-1) : '';

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <>
      {guide && (
        <>
          <div className="">
            <p className="hidden">size_guide_key: {guide.size_guide_key}</p>
            <button
              type="button"
              onClick={openModal}
              className="text-sm font-normal underline text-gray-400 hover:text-black"
            >
              {t('SIZES_GUIDE')}
            </button>
          </div>

          <Transition appear show={isOpen}>
            <Dialog
              as="div"
              className="fixed inset-0 z-10 overflow-y-auto"
              onClose={closeModal}
            >
              <div className="min-h-screen px-4 text-center">
                <DialogBackdrop className="fixed inset-0 bg-black opacity-30" />

                <TransitionChild
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <DialogBackdrop className="fixed inset-0" />
                </TransitionChild>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span
                  className="inline-block h-screen align-middle"
                  aria-hidden="true"
                >
                  &#8203;
                </span>
                <TransitionChild
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <div className="inline-block w-full max-w-5xl pb-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                    <DialogTitle
                      as="div"
                      className="flex justify-between items-center text-lg font-bold text-black font-sans bg-modalgrey px-6 py-4"
                    >
                      <h3 className="text-2xl font-bold text-black font-sans">
                        {t('SIZES_GUIDE')} ({sizeMetric})
                      </h3>
                      <button
                        className="text-center bg-white text-primary rounded-full w-8 h-8 flex justify-center items-center"
                        onClick={closeModal}
                      >
                        <StyledImage
                          src={closeimg}
                          className="flex justify-center align-center"
                          alt="close icon"
                        />
                      </button>
                    </DialogTitle>
                    <div className="pt-6 px-6 flex flex-col md:flex-row items-center justify-between">
                      {guide.size_guide_html && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: guide.size_guide_html
                          }}
                          className="w-full md:mr-2"
                        />
                      )}
                      {guide.size_guide_image && (
                        <img
                          src={guide.size_guide_image || ''}
                          alt="sizeguide"
                          className="p-5 h-50vh"
                        />
                      )}
                    </div>
                  </div>
                </TransitionChild>
              </div>
            </Dialog>
          </Transition>
        </>
      )}
    </>
  );
}
